export default {"src":"/_next/static/media/DateIcon.8c63b9e8.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};